import { APPID, APPVERSION } from "../common/globals";
import { BASE_AXIOS } from "../config";

export const apiPutNextReviewDate = async (request, type) => {
    let form = new FormData();
    let obj = {
        mcid: request.mcid,
        gameMode: request.gamemode,
        key: request.key,
        deckID : request.deckID,
        questionID : request.questionID,
        hourvar : request.hourvar,
    };

    form.append("mcid", request.mcid);
    form.append("gameMode", request.gamemode);
    form.append("key", request.key);
    form.append("deckID", request.deckID);
    form.append("questionID", request.questionID);
    form.append("hourvar", request.hourvar);

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "putNextReviewDate"
            },
            data: form
        });
        let temp = response.data;

        return temp[0];

    } catch(error) {
        throw error;
    }
}